import React from 'react';
import { Container, Grid, Wrap, WrapItem } from '@fiverr-private/layout_components';
import { Select, Option } from '@fiverr-private/forms';
import { Typography } from '@fiverr-private/typography';
import { PressReleaseCard } from '../PressReleaseCard';
import { PressReleasesHeader } from '../PressReleasesHeader';
import { PressRelease } from '../../../types/types';
import { getYears } from '../../utils';

interface MainPageProps {
  pressReleases: PressRelease[];
  selectedYear?: string;
}

const years = getYears();

export const MainPage = ({ pressReleases = [], selectedYear = '' }: MainPageProps) => {
  const handleYearChange = (year: string) => {
    window.location.assign(year ? `/news/press-releases?year=${year}` : '/news/press-releases');
  };

  return (
    <Container borderBottomWidth="sm" borderColor="grey_500" borderStyle="solid" justifyContent="center">
      <Container
        marginX={{ lg: 'auto' }}
        padding={{ default: '5', md: '8' }}
        maxWidth={{ default: '100%', lg: '1400px' }}
      >
        <Wrap gap="5" marginBottom={'12'} marginTop={{ lg: '8' }}>
          <WrapItem flexBasis="100%" flexGrow={1}>
            <PressReleasesHeader />
          </WrapItem>
          <WrapItem flexBasis="100%" flexGrow={1}>
            <Select
              placeholder="By year"
              defaultValue={{ item: selectedYear }}
              onChange={({ item }) => handleYearChange(item as string)}
            >
              <Option value="">Recent</Option>
              {years.map((year) => (
                <Option key={year} value={year.toString()}>
                  {year}
                </Option>
              ))}
            </Select>
          </WrapItem>
        </Wrap>
        {pressReleases.length ? (
          <Grid gap="8" templateColumns={{ default: '100%', md: '50%_50%', lg: '33%_33%_33%' }}>
            {pressReleases.map((release) => (
              <PressReleaseCard release={release} key={release.id} />
            ))}
          </Grid>
        ) : (
          <Typography>Something went wrong, no press releases found</Typography>
        )}
      </Container>
    </Container>
  );
};
